import ApiClient from "../api/client"

const apiClient = new ApiClient()

export const useApiClient = (): ApiClient => {
  return apiClient
}
